module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12 header"
  }, [_c('router-link', {
    staticClass: "material-icons add-link",
    attrs: {
      "tag": "i",
      "to": "/recipes/new"
    }
  }, [_vm._v("add")]), _vm._v(" "), _c('h1', [_vm._v("Recipes")])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes"
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.recipes), function(recipe, index) {
    return _c('router-link', {
      staticClass: "recipe",
      attrs: {
        "tag": "div",
        "to": '/recipes/' + recipe['.key']
      }
    }, [_c('div', {
      staticClass: "list-item"
    }, [_c('h3', [_vm._v(_vm._s(recipe.title))])])])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1148d724"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecipesStart.vue
// module id = 128
// module chunks = 0